var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.products),function(product,index){return _c('base-product',_vm._b({key:index},'base-product',product,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }